export default {
  "content": "<title>Easel</title><rect x=\"48\" y=\"80\" width=\"416\" height=\"272\" rx=\"32\" ry=\"32\" class=\"ionicon-fill-none ionicon-stroke-width\"/><path d=\"M256 416v-64m0-272V48m144 416l-32-112M112 464l32-112\" class=\"ionicon-fill-none ionicon-stroke-width\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};